@let counter =
    completedUploads() +
    ' / ' +
    notCanceledAttachmentsCount() +
    ('POST.LABEL_ATTACHMENTS_COUNTER' | translate);

<interacta-live-status [message]="completedUploads() ? counter : null" />
@if (uploadState() && uploadState().isDialogOpen && displayedAttachments()) {
    <div
        class="relative flex w-464 -translate-y-full flex-col space-y-16 rounded-t-xl border border-border-300 bg-surface-A px-16 py-18 shadow-upload"
        [ngClass]="{
            'h-56': isDialogCompact(),
        }"
    >
        <!-- header -->
        <div class="flex items-center justify-between">
            <span class="typo-sm-bold">{{ counter }}</span>
            <div class="flex items-center">
                <button
                    interacta-icon-button
                    type="button"
                    [icon]="isDialogCompact() ? 'chevron-big-up' : 'minus'"
                    [label]="
                        (isDialogCompact()
                            ? 'SHARED.BUTTON.EXPAND'
                            : 'SHARED.BUTTON.COLLAPSE'
                        ) | translate
                    "
                    [size]="'small'"
                    [style]="'text'"
                    (click)="isDialogCompact() ? expand() : collapse()"
                ></button>
                <button
                    interacta-icon-button
                    type="button"
                    [disabled]="hasPendingUploads()"
                    [icon]="'close'"
                    [label]="'UPLOAD.CLOSE' | translate"
                    [size]="'small'"
                    [style]="'text'"
                    (click)="close()"
                ></button>
            </div>
        </div>
        @if (!isDialogCompact()) {
            @if (hasPendingUploads()) {
                <button
                    class="flex w-full justify-end rounded-4 bg-surface-100 px-8 py-4 typo-xs-bold text-text-mid-contrast"
                    type="button"
                    (click)="cancelNotYetLoadedUploads()"
                >
                    {{ 'UPLOAD.CANCEL_LOADING' | translate }}
                </button>
            }

            <!-- uploads -->
            <div class="flex max-h-264 flex-col overflow-y-auto smooth-scroll">
                @for (
                    item of displayedAttachments();
                    track item.fileItem?._file || $index
                ) {
                    <interacta-upload-attachment-item
                        [attachment]="item"
                        (cancelUpload)="cancelUpload(item)"
                        (retryUpload)="retryUpload($index, item)"
                    />
                    @if (!$last) {
                        <interacta-separator [thickness]="'soft'" />
                    }
                }
            </div>
        }
    </div>
}
